import { render, staticRenderFns } from "./DiskIopsGraph.vue?vue&type=template&id=2263a114"
import script from "./DiskIopsGraph.vue?vue&type=script&lang=js"
export * from "./DiskIopsGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports